<template lang="pug">
  div
    div(v-show="false")
      MapInfo(ref="mapInfo" :info="data.info")
</template>

<script>
import MapInfo from './MapInfo'

export default {
  inject: ['google', 'map'],
  components: {
    MapInfo
  },
  data () {
    return {
      index: -1,
      marker: null,
      infoWindow: null,
      selectedShopId: null
    }
  },
  props: {
    data: {
      required: true,
      type: Object
    }
  },
  mounted () {
    const {Marker, LatLng, InfoWindow} = this.google.maps
    this.marker = new Marker({
      zIndex: this.data.zIndex,
      position: new LatLng({
        lat: this.data.lat,
        lng: this.data.lng
      }),
      map: this.map,
      icon: this.data.icon
    })
    this.infoWindow = new InfoWindow({content: this.$refs.mapInfo.$el})
    this.infoWindow.addListener('closeclick', this.unselect)
    this.marker.addListener('click', this.select)
  },
  watch: {
    selectedShopId (newVal, oldVal) {
      if (newVal === this.data.shopId) {
        this.infoWindow.open(this.map, this.marker)
      } else {
        this.infoWindow.close()
      }
    }
  },
  methods: {
    unload () {
      this.marker.setMap(null)
    },
    select () {
      this.selectedShopId = this.data.shopId
    },
    unselect () {
      this.selectedShopId = null
    }
  }
}
</script>

<style lang="sass" scoped>
</style>
